/**
 * Our Partners - Load More Functionality
 */

(function ($) {
    "use strict";

    /**
     * Initialize load more functionality
     */
    function initLoadMore() {
        // Handle load more button clicks
        $(document).on("click", ".our-partners .load-more-btn", function (e) {
            e.preventDefault();

            const $button = $(this);

            // Get current page from button data attribute (default to 1 if not set)
            let currentPage = parseInt($button.data("current-page")) || 1;

            // Check if button is already loading
            if ($button.hasClass("loading")) {
                return;
            }

            // Add loading state
            $button.addClass("loading").prop("disabled", true);
            const originalText = $button.text();
            const loadingText = $button.attr("data-loading-text") || "Loading...";
            $button.text(loadingText);

            // Find the corresponding feed list container
            const $container = $button.closest(".our-partners").find(".external-feed-list");

            // Make AJAX request
            $.ajax({
                url: atrg_ajax.ajax_url,
                type: "POST",
                data: {
                    action: "load_more_feed_items",
                    nonce: atrg_ajax.nonce,
                    current_page: currentPage,
                    current_lang: atrg_ajax.current_lang,
                },
                success: function (response) {
                    console.log("AJAX response:", response);

                    if (response.success) {
                        // Append new items to the feed list
                        $container.append(response.data.html);

                        // Update current page
                        $button.data("current-page", response.data.current_page);

                        // Hide button if no more items
                        if (!response.data.has_more) {
                            $button.fadeOut(300, function () {
                                $(this).closest(".load-more-btn__wrapper").hide();
                            });
                        }
                    } else {
                        // Handle error
                        console.error("Error loading more items:", response.data.message);

                        // Hide button if no more items
                        $button.fadeOut(300, function () {
                            $(this).closest(".load-more-btn__wrapper").hide();
                        });
                    }
                },
                error: function (xhr, status, error) {
                    console.error("AJAX error:", error);
                    alert("Failed to load more items. Please try again.");
                },
                complete: function () {
                    // Remove loading state
                    $button.removeClass("loading").prop("disabled", false);
                    $button.text(originalText);
                },
            });
        });
    }

    // Initialize on document ready
    $(document).ready(function () {
        initLoadMore();
    });
})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
    /**
     * Tabs handler.
     */
    if (document.querySelector(".tabs") != null) {
        // Select all tab blocks on the page.
        const tabsBlocks = document.querySelectorAll(".tabs");

        tabsBlocks.forEach((block) => {
            // Select only direct child tab headers and tab content containers within this block
            // This prevents interference with nested tab blocks
            const tabNavigation = block.querySelector(":scope > .tabs__nav");
            const tabContent = block.querySelector(":scope > .tabs__content");

            if (!tabNavigation || !tabContent) return;

            const tabItems = tabNavigation.querySelectorAll(".tabs__item");
            const tabContainers = tabContent.querySelectorAll(":scope > .tabs__container");

            // Add ID attributes to tab items if they don't have them
            tabItems.forEach((tab, index) => {
                if (!tab.id) {
                    const containerId = tab.getAttribute("data-container_id");
                    tab.id = containerId ? `tab-${containerId}` : `tab-${index}`;
                }
            });

            // Function to activate a specific tab
            function activateTab(tab) {
                // Remove active class from all tabs and containers in this specific block only
                tabItems.forEach((t) => t.classList.remove("tabs__item--active"));
                tabContainers.forEach((c) => c.classList.remove("tabs__container--active"));

                // Add active class to the clicked tab
                tab.classList.add("tabs__item--active");

                // Get the corresponding container ID from data attribute
                const targetId = tab.getAttribute("data-container_id");
                const targetContainer = tabContent.querySelector(`#${targetId}`);

                // Activate the target container if it exists
                if (targetContainer) {
                    targetContainer.classList.add("tabs__container--active");

                    // Smooth scroll to the target container only if .tabs--no-scroll class is not present
                    if (!block.classList.contains("tabs--no-scroll")) {
                        targetContainer.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    }

                    // Trigger a custom event when tab is activated
                    const tabActivatedEvent = new CustomEvent("tabActivated", {
                        detail: {
                            tab: tab,
                            container: targetContainer,
                            tabId: tab.id,
                            containerId: targetId,
                        },
                    });
                    document.dispatchEvent(tabActivatedEvent);
                }
            }

            // Check URL hash and activate corresponding tab
            function checkHashAndActivateTab() {
                const hash = window.location.hash.substring(1); // Remove # from hash
                if (hash) {
                    const targetTab = block.querySelector(`#${hash}`);
                    if (targetTab && targetTab.classList.contains("tabs__item")) {
                        activateTab(targetTab);
                    }
                }
            }

            // Activate tab on initial load
            checkHashAndActivateTab();

            // Listen for hash changes
            window.addEventListener("hashchange", checkHashAndActivateTab);

            tabItems.forEach((tab) => {
                tab.addEventListener("click", function () {
                    activateTab(tab);

                    // Update URL hash when tab is clicked
                    if (tab.id) {
                        history.pushState(null, null, `#${tab.id}`);
                    }
                });
            });
        });
    }
});
